import { Action } from 'redux';
import { SalesByCategoryReport } from 'model/SalesByCategoryReport';

export const SALES_BY_CATEGORY_REPORT_GET_START = 'SALES_BY_CATEGORY_REPORT_GET_START';
export const SALES_BY_CATEGORY_REPORT_GET_SUCCESS = 'SALES_BY_CATEGORY_REPORT_GET_SUCCESS';
export const SALES_BY_CATEGORY_REPORT_GET_ERROR = 'SALES_BY_CATEGORY_REPORT_GET_ERROR';

type SalesByCategoryGetStartAction = Action<typeof SALES_BY_CATEGORY_REPORT_GET_START>;

interface SalesByCategoryGetSuccessAction extends Action<typeof SALES_BY_CATEGORY_REPORT_GET_SUCCESS> {
    payload: {
        report: SalesByCategoryReport;
    };
}

type SalesByCategoryGetErrorAction = Action<typeof SALES_BY_CATEGORY_REPORT_GET_ERROR>;

export type SalesByCategoryReportAction =
    | SalesByCategoryGetStartAction
    | SalesByCategoryGetSuccessAction
    | SalesByCategoryGetErrorAction;
